import { useEffect } from 'react'

import { useBucket } from '@mc/experiments-react'
import { trackExperimentViewed } from '@mc/track-event'

import { MEMBERS_ALSO_LIKED_EXP_FLAG } from './constants'

export const useMembersAlsoLikedExperiment = () => {
  const bucket = useBucket(MEMBERS_ALSO_LIKED_EXP_FLAG)

  useEffect(() => {
    trackExperimentViewed(MEMBERS_ALSO_LIKED_EXP_FLAG)
  }, [])

  return {
    isPen4715Variant: bucket === 'variant_1',
  }
}
